import React from "react"
import cn from "classnames";
import * as styles from "./ContentWrap.module.scss"

const ContentWrap = ({children, width = "wide", withMb = false}) => {
  return (
    <div className={cn(
      styles.root,
      width === "wide" && styles.wide,
      width === "thin" && styles.thin,
      width === "normal" && styles.normal,
      width === "maxWidth" && styles.maxWidth,
      withMb && styles.marginBottom,
    )}>
      {children}
    </div>
  )
}

export default ContentWrap
